import React, { useState } from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import ExcelJS from 'exceljs';

const ExportarDetallesArchivos = ({ 
  files,
  project,
  month,
  filesWithUser,
  filesWithoutUser
}) => {
  const [exporting, setExporting] = useState(false);

  const getCleanFileName = (name) => {
    return name.replace(/^\d+-/, "");
  };

  const exportarAExcel = async () => {
    setExporting(true);
    
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Detalles Archivos');
      const estiloTitulo = {
        font: { bold: true, size: 16, color: { argb: 'FFFFFF' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '2C3E50' } },
        alignment: { horizontal: 'center', vertical: 'middle' }
      };

      const estiloSubtitulo = {
        font: { bold: true, size: 12, color: { argb: '000000' } }, // Negro
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'E3F2FD' } },
        alignment: { horizontal: 'center', vertical: 'middle' },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      };

      const estiloCabecera = {
        font: { bold: true, color: { argb: '000000' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DDEBF7' } }, 
        alignment: { horizontal: 'center', vertical: 'middle' },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      };

      const estiloContenidoTabla = {
        font: { color: { argb: '000000' } },
        alignment: { vertical: 'middle' },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      };

      const estiloContenidoCentrado = {
        ...estiloContenidoTabla,
        alignment: { horizontal: 'center', vertical: 'middle' }
      };

      const estiloEtiquetaEstadistica = {
        font: { bold: true, color: { argb: '000000' } },
        alignment: { horizontal: 'left', vertical: 'middle' },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F5F5F5' } },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      };

      const estiloValorEstadistica = {
        font: { color: { argb: '000000' } }, 
        alignment: { horizontal: 'center', vertical: 'middle' },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      };

      worksheet.mergeCells('A1:E1');
      const titulo = worksheet.getCell('A1');
      titulo.value = `DETALLES DE ARCHIVOS - ${project} - ${month}`;
      titulo.style = estiloTitulo;
      const fecha = new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
      
      worksheet.mergeCells('A2:E2');
      worksheet.getCell('A2').value = `Generado el: ${fecha}`;
      worksheet.getCell('A2').style = {
        font: { italic: true, color: { argb: '7F8C8D' } },
        alignment: { horizontal: 'left' }
      };

      worksheet.addRow([]);
      worksheet.mergeCells('A4:E4');
      worksheet.getCell('A4').value = 'RESUMEN DEL PROYECTO';
      worksheet.getCell('A4').style = estiloSubtitulo;

      const porcentajeAsignados = files.length > 0 
        ? Math.round((filesWithUser / files.length) * 100) 
        : 0;
      const porcentajePendientes = files.length > 0 
        ? Math.round((filesWithoutUser / files.length) * 100) 
        : 0;
      const statsRow1 = worksheet.addRow([
        'Total de archivos:',
        files.length,
        'Con usuario:',
        `${filesWithUser} (${porcentajeAsignados}%)`,
        ''
      ]);

      statsRow1.eachCell((cell, colNumber) => {
        if (colNumber === 1 || colNumber === 3) { 
          cell.style = estiloEtiquetaEstadistica;
        } else if (colNumber === 2 || colNumber === 4) { 
          cell.style = estiloValorEstadistica;
        }
      });

      const statsRow2 = worksheet.addRow([
        'Sin usuario:',
        `${filesWithoutUser} (${porcentajePendientes}%)`,
        'Proyecto:',
        project,
        ''
      ]);

      statsRow2.eachCell((cell, colNumber) => {
        if (colNumber === 1 || colNumber === 3) { 
          cell.style = estiloEtiquetaEstadistica;
        } else if (colNumber === 2 || colNumber === 4) { 
          cell.style = estiloValorEstadistica;
          if (colNumber === 2) {
            cell.font = { color: { argb: '000000' } }; 
          }
        }
      });

      const statsRow3 = worksheet.addRow([
        'Mes:',
        month,
        'Tasa de asignación:',
        `${porcentajeAsignados}%`,
        ''
      ]);

      statsRow3.eachCell((cell, colNumber) => {
        if (colNumber === 1 || colNumber === 3) { 
          cell.style = estiloEtiquetaEstadistica;
        } else if (colNumber === 2 || colNumber === 4) {
          cell.style = estiloValorEstadistica;
          if (colNumber === 4) {
            if (porcentajeAsignados >= 90) {
              cell.font = { color: { argb: '2E7D32' } }; 
            } else if (porcentajeAsignados >= 70) {
              cell.font = { color: { argb: 'FF9800' } };
            } else {
              cell.font = { color: { argb: 'D32F2F' } }; 
            }
          }
        }
      });

      worksheet.addRow([]);
      worksheet.addRow([]);
      const cabecera = ['#', 'Archivo', 'Usuario', 'Cédula', 'Estado'];
      const filaCabecera = worksheet.addRow(cabecera);
      filaCabecera.eachCell((cell) => {
        cell.style = estiloCabecera;
      });
      files.forEach((file, index) => {
        const nombreLimpio = getCleanFileName(file.name);
        const tieneUsuario = file.participante;
        const nombreUsuario = tieneUsuario 
          ? file.participante.nombre_participante 
          : 'SIN ASIGNAR';
        const cedula = file.cedula || 'N/A';
        const estado = tieneUsuario ? 'ASIGNADO' : 'PENDIENTE';

        const fila = [
          index + 1,
          nombreLimpio,
          nombreUsuario,
          cedula,
          estado
        ];

        const filaDatos = worksheet.addRow(fila);
        filaDatos.eachCell((cell, colNumber) => {
          cell.style = estiloContenidoCentrado;
          if (colNumber === 2) {
            cell.alignment = { horizontal: 'left', vertical: 'middle' };
            cell.font = { color: { argb: '000000' } }; 
          }
          if (colNumber === 3) {
            cell.alignment = { horizontal: 'left', vertical: 'middle' };
            cell.font = { color: { argb: '000000' } }; 
          }
          if (colNumber === 5) {
            if (tieneUsuario) {
              cell.font = { color: { argb: '2E7D32' } };
            } else {
              cell.font = { color: { argb: 'D32F2F' } };
            }
          }
          if (colNumber === 4 && cedula === 'N/A') {
            cell.font = { color: { argb: '757575' }, italic: true }; 
          }
        });
      });
      worksheet.columns = [
        { width: 8 },   
        { width: 50 },  
        { width: 35 },  
        { width: 15 },  
        { width: 15 }   
      ];
      let rowIndex = 11; 
      while (rowIndex <= worksheet.rowCount) {
        const row = worksheet.getRow(rowIndex);
        const firstCellValue = row.getCell(1).value;
        if (typeof firstCellValue === 'number') {
          if (rowIndex % 2 === 0) {
            row.eachCell((cell) => {
              if (cell.col <= 5) {
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F8F9FA' } };
              }
            });
          }
        }
        rowIndex++;
      }
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      const nombreSeguroProyecto = project.replace(/[^a-zA-Z0-9]/g, '_').substring(0, 30);
      const nombreSeguroMes = month.replace(/[^a-zA-Z0-9]/g, '_').substring(0, 20);
      const nombreArchivo = `Detalles_${nombreSeguroProyecto}_${nombreSeguroMes}_${new Date().toISOString().split('T')[0]}.xlsx`;
      
      link.href = url;
      link.download = nombreArchivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error('Error al exportar:', error);
      alert('Error al exportar el archivo. Por favor, intente de nuevo.');
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      type="primary"
      icon={<DownloadOutlined />}
      onClick={exportarAExcel}
      loading={exporting}
      disabled={!files || files.length === 0}
      title="Exportar detalles a Excel"
      size="small"
    >
      Exportar Excel
    </Button>
  );
};

export default ExportarDetallesArchivos;